export const GET_ALL_QUERY_KEY = 'product-updates';
